import { render, staticRenderFns } from "./EAcoesDoPeriodo.vue?vue&type=template&id=1d237e82"
import script from "./EAcoesDoPeriodo.vue?vue&type=script&lang=js"
export * from "./EAcoesDoPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports